import React, { useState } from "react";
import {
  getFromlocalstorage,
  saveTolocalstorage,
} from "../../../../../component/MaHoaDuLieu/MaHoaDuLieu";
import Loading from "../../../../../component/Loading/Loading";
import Notify from "../../../../../component/Notify/Notify";
import ModalBank from "../ModalBank/ModalBank";
import "./Bank.scss";

const DepositQR = () => {
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const data = JSON.parse(getFromlocalstorage("data_u"));

  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [bankData, setBankData] = useState(null);

  const depositAmounts = [
    100,
    500,
    1000,
    5000,
    10000,
    20000,
    30000,
    40000,
  ];

  const handleDeposit = async () => {
    const amountToSend = customAmount
      ? Number(customAmount)
      : selectedAmount;

    if (!amountToSend) {
      setMessage("กรุณาเลือกหรือกรอกจำนวนเงิน");
      return;
    }

    if (amountToSend < 100) {
      setMessage("ยอดฝากขั้นต่ำ 100 THB");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/naptien/${data._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: amountToSend,
          type: "deposit",
        }),
      });

      const resData = await response.json();

      if (response.ok) {
        saveTolocalstorage(
          "data_b",
          JSON.stringify(resData.bankjson)
        );

        setBankData(resData.transactions);
      } else {
        setMessage(
          resData.message || "ฝากเงินไม่สำเร็จ"
        );
      }
    } catch (error) {
      setMessage("เกิดข้อผิดพลาดในการเชื่อมต่อ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="deposit-amount-container">
      <Loading isLoading={loading} />

      <h2>ฝากเงินผ่านการโอนธนาคาร</h2>

      <div className="amount-list">
        {depositAmounts.map((amount) => (
          <div
            key={amount}
            className={`amount-item ${
              selectedAmount === amount
                ? "selected"
                : ""
            }`}
            onClick={() => {
              setSelectedAmount(amount);
              setCustomAmount(amount.toString());
            }}
          >
            {amount.toLocaleString()} THB
          </div>
        ))}

        {/* ช่องกรอกจำนวนเงิน */}
        <input
          type="number"
          className="amount-input"
          placeholder="กรอกจำนวนเงินอื่น..."
          value={customAmount}
          onChange={(e) => {
            setCustomAmount(e.target.value);
            setSelectedAmount(null);
          }}
        />
      </div>

      <div className="form-actions">
        <button
          className="btn btn-primary"
          onClick={handleDeposit}
        >
          ดำเนินการต่อ
        </button>
      </div>

      {message && (
        <Notify
          message={message}
          type="error"
          setcontent={setMessage}
        />
      )}

      {bankData && (
        <ModalBank
          onClose={() => setBankData(null)}
          bankData={{
            ...bankData,
            amount: customAmount || selectedAmount,
          }}
        />
      )}
    </div>
  );
};

export default DepositQR;